import { Component, OnInit } from '@angular/core';
import {GameLogicService} from "../../services/game-logic.service";
import {Square} from "../../classes/Square";
import {Board} from "../../classes/Board";
import {Result} from "../../constants/Result";


@Component({
  selector: 'app-minesweeper',
  templateUrl: './minesweeper.component.html',
  styleUrls: ['./minesweeper.component.css']
})
export class MinesweeperComponent implements OnInit {

  public newBoardHeight: number; //updated when user changes from game settings in sidebar component
  public newBoardLength: number; //updated when user changes from game settings in sidebar component
  public newNumberOfMines: number; //updated when user changes from game settings in sidebar component

  public board:Board;

  public mineLocations:number[] = [];
  public containerViewClass:string;

  public time: number;
  public timerId: any;

  public firstMove: boolean;
  public gameOver: boolean;
  public result: number;

  constructor(private gameLogicService: GameLogicService) { }

  ngOnInit() {
    this.newBoardLength = 9;
    this.newBoardHeight = 9;
    this.newNumberOfMines = 10;

    this.setupGame()
  }

  setupGame(){
    this.containerViewClass = "container";
    this.firstMove = true;
    this.gameOver = false;
    this.time = 0;
    this.result = Result.noResult;
    clearInterval(this.timerId);
    this.prepareBoard();
  }

  prepareBoard(){
    let emptyBoard: Square[][] = []; //initialize empty array of squares
    this.board = new Board(emptyBoard,this.newBoardLength*this.newBoardHeight,this.newBoardLength,this.newBoardHeight,this.newNumberOfMines);
    this.mineLocations = this.gameLogicService.getMinePositions(this.board);
    this.board = this.gameLogicService.addSquaresToBoard(this.board,this.mineLocations);
  }

  squareClicked(row: number, column: number){
    if(this.gameOver){ // dont do anything if game is already over
      return;
    }

    if(this.firstMove){ //start timer if first move
      this.setTimer();
      this.firstMove = false;
    }

    if(this.gameLogicService.checkIfMarked(this.board,row,column)){
      return;
    }

    if (this.gameLogicService.checkIfMinePresent(this.board,row,column)){ //end the game as lost if mine is hit
      this.endGame(false);
    }else{
      this.board = this.gameLogicService.checkNeighbors(row,column,this.board);
      if(this.board.squaresRemaining==0){ //end the game as won if all the squares without mines have been opened
        this.endGame(true);
      }
    }
  }

  squareMarked(row:number, column:number){
    if(this.gameOver){ // do nothing if game is already over
      return;
    }
    if(this.board.squares[row][column].clicked){ // do nothing if square has already been clicked before
      return;
    }
    this.board = this.gameLogicService.markOrUnmarkSquare(row,column,this.board);
  }

  endGame(winner:boolean){ //end the game as the winner or the loser
    clearInterval(this.timerId);
    this.gameOver = true;
    if(!winner){
      this.result = Result.lose;
      this.board = this.gameLogicService.gameLost(this.board);
    }else{
      this.result = Result.win;
      this.board = this.gameLogicService.gameWon(this.board);
      this.containerViewClass = "container won"; //change container class to show animation
    }
  }

  restartGame(boardProperties: any){ //called when 'new game' button is clicked from sidebar component
    this.newBoardLength = boardProperties.newLength;
    this.newBoardHeight = boardProperties.newHeight;
    this.newNumberOfMines = boardProperties.newMines;
    this.setupGame();
  }

  setTimer(){
    this.time = 0;
    this.timerId = setInterval(() =>
    {
      this.time = this.time +1
    }, 1000)  ;
  }
}



// WEBPACK FOOTER //
// ./src/app/minesweeper/components/minesweeper/minesweeper.component.ts